module.exports = __webpack_public_path__ + "img/Main-image.8ef945a5.png";